<template>

<div class="page container">

        <div class="row">
            <div class="col-6">
            <div class="col-6 text-right">

                <img class="w-70 pull-right" alt="Vue logo" src="../assets/logo.svg">
            </div>
          </div>
          <div class="col-6">
           
          </div>

        </div>


         <div class="row mt-4">
                <div class="col">

                       <h1 class='mb-4'> Recebemos seu pedido. </h1>

                      <div  class='texto' style="font-size:16px">
                      <p> Para concluir sua compra efetue o pagamento no valor de <br/> <b>R$ {{$store.state.pedidosFeitoCliente.total}}</b> por PIX ou transferência bancária para:</p>
                      <div class='alert alert-info'>
                        <h5> <b>PIX</b></h5>
                        <div>11677708115</div>
                        <br/>
                        <h5><b> Banco do Brasil</b></h5>
                        <h5>
                        Ag. 1606-3 <br />
                        CC. 149821-5 <br />
                        CPF: 116777081-15 <br />
                        Nome: Jorge Artur C. Oliveira<br />
                        <br />
                        <p> Envie o comprovante para o <br /> <a href ="https://wa.me/55619938-8232" target="_blank"> WhatsApp <b> 61 9938-8232</b> </a> </p>
                        </h5>
                    </div>
                    <p> </p>
                    <p>Seu pedido será entregue quarta-feira entre 7 e 15 horas</p>
                    
                    <p>Agradecemos!</p>
            
            
            
            <router-link to="/" class='btn btn-primary mb-5 mt-4'> Fazer um novo Pedido </router-link>
            </div>

                </div>
        </div>



</div>

</template>


<script>
    
    export default {



    computed:{
      listaProdutos:function(){
          return this.$store.getters.lista
      },
      minhacesta:function(){
          return this.$store.getters.minhacesta
      },
      total:function(){
          return this.$store.getters.total
      }
    },
    }


</script>